import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../actionTypes';

/**
 * @typedef {{
 *  thresholds: {
 *    'min-price': number,
 *    'max-price': number,
 *  }
 * }} FinalInvoiceConfig
 */

/**
 * @typedef {{
 *  conversation: {
 *    message: Partial<import("../types").AppChannelIntegration>
 *  },
 *  media: Partial<import("../types").AvailableNodeFileConfiguration>,
 *  tire: {
 *    speedIndexes: string[],
 *    types: import("constants/InterventionConstants").TireTypeEnum[],
 *    positions: import("modules/interventions/types/projections/detailed-intervention").TirePositionEnum[],
 *  },
 *  dealer: {
 *    config : {
 *      integration: Partial<import("../types").AppConfigIntegration>,
 *    }
 *  },
 *  users: {
 *    email : {
 *      allowedReactivations: number,
 *    }
 *  },
 *  'final-invoice': FinalInvoiceConfig,
 * }} AppConfigReducer
 */

/**
 * @param {AppConfigReducer} state
 * @param {import('../types').FetchAppConfigurationSuccessAction} action
 * @returns {AppConfigReducer}
 */
const update = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default createReducer({}, {
  [actionTypes.FETCH_APP_CONFIGURATION_SUCCESS]: update,
});
